/* Atelier appearance and clearance for Shopify's preview toolbar. */
(() => {
  'use strict';
  const stylesheet = document.currentScript?.dataset.style;
  if (!stylesheet) return;
  let widgetHost, previewFrame;
  function syncPreview() {
    if (!widgetHost) return;
    const box = previewFrame?.getBoundingClientRect();
    const visible = box && box.height > 0 && getComputedStyle(previewFrame).visibility !== 'hidden';
    widgetHost.style.setProperty('--clara-preview-offset', visible ? Math.min(80, Math.ceil(box.height)) + 'px' : '0px');
  }
  const previewResize = typeof ResizeObserver === 'function' ? new ResizeObserver(syncPreview) : null;
  function connect() {
    if (!document.querySelector('script[data-brand="thundernoise"]')) return;
    if (!widgetHost?.isConnected) {
      for (const host of document.body.children) {
        const root = host.shadowRoot;
        if (!root?.querySelector('.launch .bubble')) continue;
        if (!root.querySelector('[data-atelier-clara-style]')) {
          const link = document.createElement('link');
          link.rel = 'stylesheet'; link.href = stylesheet; link.dataset.atelierClaraStyle = '';
          root.append(link); host.dataset.atelierClara = '';
        }
        widgetHost = host; break;
      }
    }
    const frame = document.getElementById('PBarNextFrame');
    if (frame !== previewFrame) {
      previewResize?.disconnect(); previewFrame = frame;
      if (previewFrame) previewResize?.observe(previewFrame);
    }
    syncPreview();
  }
  connect();
  // Both the widget and Shopify's toolbar can be appended after document load.
  const observer = new MutationObserver(connect);
  observer.observe(document.body, {childList:true});
  window.addEventListener('resize', syncPreview, {passive:true});
  window.addEventListener('pagehide', () => {
    observer.disconnect(); previewResize?.disconnect(); window.removeEventListener('resize', syncPreview);
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    connect(); observer.observe(document.body, {childList:true});
    if (previewFrame) previewResize?.observe(previewFrame);
    window.addEventListener('resize', syncPreview, {passive:true});
  });
})();
